import { TabLabel } from '@app/fallback-report/table-nav/table-nav.component';
import { FallbackReportExtension } from './fallback-report-extension';
import { factoryOpCoTabLabels } from './utilities';

/** this class configures the fallbackReport for use when the opCo is ACE */
export class ACEFallbackExtension extends FallbackReportExtension {
  readonly opCo = 'ACE';

  private ACEFields = [
    'PLACE_NAME',
    'COUNTY',
    'CUSTOMERS_AFFECTED',
    'CUSTOMERS_SERVED',
    'PERCENT_AFFECTED',
    'NUMBER_OF_OUTAGES',
    'MORE'
  ];

  private ACEHeaders = this.ACEFields
    .slice(1)
    .map(field => field.replace(/_/g, ' '));

  TableStyle = {
    Default: 0,
    Hidden: 1,
    ACEThousands: 2,
    ACERounded: 3,
    ACERoundedPercent: 4,
    ACELink: 5
  };

  private ACEStyles: { [datafield: string]: number } = {
    PLACE_NAME: this.TableStyle.Default,
    COUNTY: this.TableStyle.Default,
    CUSTOMERS_AFFECTED: this.TableStyle.ACERounded,
    CUSTOMERS_SERVED: this.TableStyle.ACEThousands,
    PERCENT_AFFECTED: this.TableStyle.ACERoundedPercent,
    NUMBER_OF_OUTAGES: this.TableStyle.ACEThousands,
    MORE: this.TableStyle.ACELink
  };

  DataEndpoint = {
    ACEByMunicipality: '/ace/town'
  };

  DataFields = {
    ACEByMunicipality: this.ACEFields
  };

  TableCelStyles = {
    ACEByMunicipality: this.ACEStyles
  };

  TableRowHeaders = {
    ACEByMunicipality: ['MUNICIPALITY'].concat(this.ACEHeaders)
  };

  TableNavOverrides = {
    ACEByMunicipality: 'By County - Municipality'
  };

  TabLabels: Array<TabLabel>;

  TabOrder = [
    'ACEByMunicipality'
  ];

  constructor () {
    super();
    this.TabLabels = factoryOpCoTabLabels.bind(this)();
  }
}
